import { createContext } from "react";

const CssContext = createContext({});

export default CssContext;
